module.exports = __webpack_public_path__ + "media/images/landing_page/2023/header_img-7b7bc29be2c4274f840af82d1be1c69f.webp";